export { SpaceBackdrop, type SpaceBackdropFade } from "#space-backdrop";
export { SPACE_CHROME_COLOR, SPACE_CHROME_COLOR_VARIABLE } from "#space-backdrop-palette";
export { createSpaceBackdropStarfield } from "#space-backdrop-starfield";
export { SpaceSkyForegroundScope, SpaceStatusBar, SpaceThemeScope } from "#space-theme-scope";
export {
  SpaceSkySurfaceContext,
  useIsOverSpaceSky,
  useIsSpaceBackgroundEnabled,
  useSpaceSurfaceColorVariable,
} from "#use-is-space-background-enabled";
